'use strict';

var _ = require('lodash');
var OnlineLogitCalibrationDataCacheService = function OnlineLogitCalibrationDataCacheService($cacheFactory, $log) {
  var dataRetrievalCache = $cacheFactory('logitCalibrationCache', {
    capacity: 50
  });
  var cachedUrls = [];
  function addUrlToList(url) {
    var index = cachedUrls.indexOf(url);
    if (index !== -1) {
      cachedUrls.splice(index, 1);
    }
    cachedUrls.push(url);
  }
  function putDataToCache(url, requestObject, cacheData) {
    var cacheKey = url + buildQueryString(requestObject);
    addUrlToList(cacheKey);
    $log.debug('Adding URL ' + cacheKey + ' to Online Logit Calibration data Cache');
    dataRetrievalCache.put(cacheKey, {
      data: cacheData
    });
  }
  function invalidateCache() {
    $log.debug('Invalidating Online Logit Calibration data Cache');
    _.forEach(cachedUrls, dataRetrievalCache.remove);
  }
  function getDataFromCache(url, requestObject) {
    var cacheKey = url + buildQueryString(requestObject);
    var cachedData = dataRetrievalCache.get(cacheKey);
    $log.debug('Cached object retrieved for key ' + cacheKey + ' is ' + cachedData);
    return cachedData ? cachedData.data : undefined;
  }
  function buildQueryString(requestObject) {
    return _.chain(requestObject).keys().reduce(function (joiner, key) {
      return joiner.concat(key + '=' + _.get(requestObject, key));
    }, []).join('&').value();
  }
  return {
    putData: putDataToCache,
    invalidate: invalidateCache,
    getData: getDataFromCache
  };
};
OnlineLogitCalibrationDataCacheService.$inject = ['$cacheFactory', '$log'];
module.exports = OnlineLogitCalibrationDataCacheService;